import { AutoComplete, Checkbox } from "antd";
import React from "react";
import style from "../../list/ListTripPlanning.module.css";

const TabTransporter = ({
  listDA,
  checkBoxListDA,
  viewDetailDA,
  checkIsExistListDA,
}) => {
  return (
    <>
      <div className="flex flex-col mt-4">
        <div className="font-roboto-medium text-lg">
          {" "}
          List Driver Associate{" "}
        </div>
        <div className="flex flex-row mt-3 justify-between gap-8">
          <div className="w-full flex justify-center items-center">
            <AutoComplete
              className=" w-full"
              placeholder="Search order code"
              size="large"
              style={{ height: "47px" }}
            />
          </div>
          <div className="w-full flex items-center justify-end"></div>
        </div>

        {/* List Order */}
        {listDA && listDA?.length > 0 ? (
          <div className="grid grid-cols-2 gap-8 mt-6 py-5 max-h-[560px] overflow-auto mb-10">
            {listDA?.map((item, index) => (
              <div
                key={index}
                className="flex flex-cols w-full h-[5.25rem] rounded-md py-[1rem] px-[0.5rem] shadow-lg"
              >
                <div
                  className={`${style.selectOptionContainer} w-[50px] flex justify-center items-center`}
                >
                  <Checkbox
                    onChange={() => checkBoxListDA(item?.delivery_associate_id)}
                    checked={
                      checkIsExistListDA(item?.delivery_associate_id)
                        ? true
                        : false
                    }
                  />
                </div>
                <div className="w-full">
                  <div className="grid grid-rows-2">
                    <p className="font-roboto font-medium text-lg text-gray-100">
                      {`${item?.delivery_associate_id}`}
                    </p>
                    <div className="grid grid-cols-2">
                      <div className="col-start-1 col-end-3 ">
                        <p className="font-roboto font-medium text-xl text-black-300">
                          {`${item.first_name} ${item.last_name} - ${item.vehicle_no}`}
                        </p>
                      </div>
                      <div
                        className="col-end-7 col-span-2 cursor-pointer"
                        onClick={() => viewDetailDA(item)}
                      >
                        <p className="font-roboto font-medium text-sm text-red-100">
                          View Detail
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-6 flex justify-center items-center font-roboto">
            No Data
          </div>
        )}
      </div>
    </>
  );
};

export default TabTransporter;
